import React, { useState, useEffect } from "react";

import "./styles.scss";
import { Album } from 'app/api/types';
import { v4 as uuidv4 } from 'uuid';

interface IProps {
  onSubmit: (data: Album) => void;
  onSuccessChange: (active: boolean) => void;
  isSubmit: boolean;
}

const AddAlbum: React.FC<IProps> = ({
  onSubmit,
  onSuccessChange,
  isSubmit
}) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const onChange = (e: any) => {
    e.target.name === "title" && setTitle(e.target.value);
    e.target.name === "description" && setDescription(e.target.value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    onSubmit({
      id: uuidv4(),
      name: title,
      description: description,
      previewUrl: '',
      resources: []
    });
  };

  const getHeight = () => {
    let height = 50;
    if (title.length > 1) height += 47;
    if (description.length > 1) height += 20;

    return height;
  };

  useEffect(() => {
    if (
      title.length > 1 &&
      description.length > 1
    )
      onSuccessChange(true);
    else onSuccessChange(false);

    isSubmit &&
      onSubmit({
        id: uuidv4(),
        name: title,
        description: description,
        previewUrl: '',
        resources: []
      });
  }, [
    title,
    description,
    onSuccessChange,
    onSubmit,
    isSubmit
  ]);

  return (
    <div className="add-phrase" style={{ height: `${getHeight()}px` }}>
      <form className="add-phrase__form" onSubmit={handleSubmit}>
        <input
          className="add-phrase__input"
          onChange={onChange}
          value={title}
          name="title"
          placeholder="Название"
          autoComplete="off"
          required
        />
        {title.length > 1 && (
          <input
            className={`add-phrase__input`}
            onChange={onChange}
            value={description}
            name="description"
            placeholder="описание альбома"
            autoComplete="off"
            required
          />
        )}
      </form>
    </div>
  );
};

export default AddAlbum;
